// extracted by mini-css-extract-plugin
module.exports = {"notesTextarea":"styles_notesTextarea__3gmXs"};